<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body,html{
    margin: 0;
    padding: 0;
}
#app {
   font-family: PingFangSC-Semibold, PingFang SC, microsoft yahei;
}
::-webkit-scrollbar {
  width: 0.05rem;
  height: 0.05rem;
  opacity: 0;
}
::-webkit-scrollbar-track {
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  border-radius: 0;
  opacity: 0;
  transition: all .2s;
  border-radius: 0.25rem;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(95, 95, 95, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/App.vue